import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlMatchResult, UrlSegment} from '@angular/router';
import {SettingsComponent} from './settings/settings.component';
import {ListComponent} from './list/list.component';
import {getProvider, validRoute} from './settings-data.service';
import {HistoryComponent} from './history/history.component';
import {NotSupportComponent} from './not-support/not-support.component';


export function containsNJTBUSValidRouteAndStop(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 2 && url[0].path.match('^([A-Za-z]*[0-9]+)|ALL$') && validRoute(url[0].path, 'NJT_BUS')
    && url[1].path.match('^[0-9]+$')) ? ({
    consumed: url,
    posParams: {
      id: new UrlSegment(url[0].path, {}),
      pid: new UrlSegment('NJT_BUS', {}),
      stop: new UrlSegment(url[1].path, {})
    }
  }) : null;
}

export function containsNJTBUSValidRoute(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 1 && url[0].path.match('^([A-Za-z]*[0-9]+)|ALL') && validRoute(url[0].path, 'NJT_BUS')) ? ({
    consumed: url,
    posParams: {
      id: new UrlSegment(url[0].path, {}),
      pid: new UrlSegment('NJT_BUS', {})
    }
  }) : null;
}

export function containsAnyRouteAndStop(url: UrlSegment[]): UrlMatchResult {
  if (url.length === 3) {
    const provider = getProvider(url[0].path);
    if (provider !== null) {
      const route = validRoute(url[1].path, provider);
      if (route === true && url[2].path.match('^[0-9]+$')) {
        return {
          consumed: url,
          posParams: {
            id: new UrlSegment(url[1].path, {}),
            pid: new UrlSegment(provider, {}),
            stop: new UrlSegment(url[2].path, {})
          }
        };
      }
    }
  }
  return null;
}


export function containsAnyRoute(url: UrlSegment[]): UrlMatchResult {
  if (url.length === 2) {
    const provider = getProvider(url[0].path);
    if (provider !== null) {
      const route = validRoute(url[1].path, provider);
      if (route === true) {
        return {
          consumed: url,
          posParams: {
            id: new UrlSegment(url[1].path, {}),
            pid: new UrlSegment(provider, {})
          }
        };
      }
    }
  }
  return null;
}

export function containsAnyStop(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 2 && url[0].path.match('^history$')) ? ({
    consumed: url,
    posParams: {vehicle: new UrlSegment(url[1].path, {})}
  }) : null;
}


export function containsAnyBlock(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 2 && url[0].path.match('^block')) ? ({
    consumed: url,
    posParams: {blockId: new UrlSegment(url[1].path, {})}
  }) : null;
}

export function experimental(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 1 && url[0].path.match('^experimental$')) ? ({
    consumed: url,
    posParams: {experimental: new UrlSegment('yes', {})}
  }) : null;
}

export function justPath(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 1 && url[0].path.toUpperCase().localeCompare('PATH') === 0) ? ({
    consumed: url,
    posParams: {
      id: new UrlSegment('SHOWALL', {}),
      pid: new UrlSegment('PATH', {})
    }
  }) : null;
}

const routes: Routes = [
  {path: '', component: ListComponent},
  {path: 'settings', component: SettingsComponent},
  {component: ListComponent, matcher: justPath},
  {component: ListComponent, matcher: containsNJTBUSValidRouteAndStop},
  {component: ListComponent, matcher: containsNJTBUSValidRoute},
  {component: ListComponent, matcher: containsAnyRouteAndStop},
  {component: ListComponent, matcher: containsAnyRoute},
  {component: SettingsComponent, matcher: experimental},
  {component: HistoryComponent, matcher: containsAnyStop},
  {component: HistoryComponent, matcher: containsAnyBlock},
  {path: '**', component: NotSupportComponent}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
